import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Typography from '@material-ui/core/Typography'
import shareIcon from 'assets/images/shareIcon.png'
import userIcon from 'assets/images/userIcon.png'

const StyledShareIcon = styled.img.attrs({ src: shareIcon })`
  color: #949494;
`

const StyledPerson = styled.img.attrs({ src: userIcon })(({ $isShareVisible }) => css`
    opacity: ${$isShareVisible ? 0.2 : 1};
    height: 24px;
    width: 24px;
    margin-left: -3px;
`)

const StyledImg = styled.img(({ $isShareVisible }) => css`
    opacity: ${$isShareVisible ? 0.2 : 1};
    height: 24px;
    width: 24px;
    border-radius: 24px;
    margin-left: -3px;
`)

const UserContainer = styled.div`
    display: flex;
    justify-content: center;
`

const UserText = styled(Typography)(({ $isShareVisible }) => css`
    color: #949494;
    padding-left: 5px;
    margin: auto;
    opacity: ${$isShareVisible ? 0.2 : 1};
`)

const AbsoluteShareIcon = styled.img.attrs({ src: shareIcon })(({ $isShareVisible }) => css`
    color: #949494;
    position: absolute;
    opacity: ${$isShareVisible ? 1 : 0};
`)


const TableTrapUserCell = ({ users, handleShare }) => {
  const [isShareVisible, setIsShareVisible] = useState(false)

  const handleUserClick = (event) => {
    handleShare()
    event.stopPropagation()
  }

  const handleHover = () => {
    setIsShareVisible(true)
  }
  const handleLeave = () => setIsShareVisible(false)

  const profileRenderer = () => {
    return (
      <UserContainer onMouseEnter={handleHover} onMouseLeave={handleLeave} onClick={handleUserClick} >
        {users.slice(0, 4).map(user => (user.imageThumbUrl ?
            <StyledImg $isShareVisible={isShareVisible} src={user.imageThumbUrl} alt={`Avatar of ${user.fullName}`}
                       key={user.trapUserId}/> :
            <StyledPerson $isShareVisible={isShareVisible} key={user.trapUserId}/>))}
        {users.length > 4 && <UserText $isShareVisible={isShareVisible}>+ {users.length - 4}</UserText>}
        <AbsoluteShareIcon $isShareVisible={isShareVisible} />
      </UserContainer>
    )
  }

  const userContent = users && users.length > 0 ? profileRenderer() : <StyledShareIcon onClick={handleUserClick} />

  return (
    userContent
  )
}

TableTrapUserCell.propTypes = {
  users: PropTypes.array,
  handleShare: PropTypes.func
}


export default TableTrapUserCell



// WEBPACK FOOTER //
// ./src/components/atoms/TableTrapUserCell.js